const handleDuration = (duration: number) => {
  duration = Math.round(duration);
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  const secondsStr = seconds < 10 ? `0${seconds.toPrecision(1)}` : seconds.toString().replace(".", "");
  return minutes + ":" + secondsStr;
};

export default handleDuration;
